<script lang="ts">
  import MocStar from '$shared/images/moc-star.svg';

  interface Props {
    value?: string;
  }

  let { value = '' }: Props = $props();

  const tooltipMsg =
    'The MOC program was created by ABMS and its 24 Member Boards to enhance the physician certification process, moving from once in a lifetime, or periodic recertification, to an ongoing commitment to continuous maintenance of high quality clinical competencies. The MOC program ensures that a participating physician is committed to lifelong learning and ongoing self-assessment in six areas of competency. While measurement of these competencies may vary according to the medical specialty, this multi-faceted assessment is carried out by all 24 Member Boards using a four-part process, including practice-based learning and improvement.';
</script>

<div class="board-moc-type">
  <div class="key">
    <div class="tooltip-content">
      <div class="star-icon">
        <img src={MocStar} alt="icon" />
      </div>
      <div class="tooltip">
        <div class="text">{tooltipMsg}</div>
      </div>
    </div>
    <div class="text">Participating in MOC</div>
  </div>
  <div class="value">{value || 'No'}</div>
  <!-- {#if !value}
    <div class="notRequired-icon"><Icon value="icon-help-circle" /></div>
  {/if} -->
</div>

<style>
  .board-moc-type {
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
    color: inherit;
  }

  .board-moc-type .key {
    width: 150px;
    display: flex;
    align-items: flex-start;
    flex-shrink: 0;
    margin-right: 16px;
    color: var(--black);
    font-weight: 500;
  }

  .board-moc-type .key .text {
    margin-left: 8px;
  }

  .board-moc-type .value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /* .notRequired-icon {
    margin-left: 4px;
    margin-top: 2px;
  } */
  .tooltip-content {
    position: relative;
    display: inline-block;
  }
  .tooltip-content .tooltip {
    width: 400px;
    color: #585c64;
    padding: 10px;
    border-radius: 3px;
    position: absolute;
    box-shadow:
      0 4px 18px 3px rgb(0 0 0 / 10%),
      0 3px 11px 1px rgb(0 0 0 / 8%);
    background: white;
    visibility: hidden;
    left: 60%;
    transform: translate(-11%, -114%);
  }
  .tooltip-content .tooltip::after {
    content: '';
    position: absolute;
    border-width: 5px;
    border-style: solid;
    border-color: white;
    top: 100%;
    left: 10%;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  .tooltip-content .text {
    color: var(--grey-dark);
    font-size: 12px;
  }
  .star-icon {
    cursor: help;
  }
  .star-icon:hover + .tooltip {
    visibility: visible;
  }
</style>
